import { LineSeg2d } from '../math/LineSeg2d';
import { ESeparateWallType } from './separateWall/SeparateWall';

export enum ERoomType {
  Default = 0,
  Office = 1,
  CorridorPassage = 2,
  ElevatorRoom = 3,
  Toilet = 4,
  Warehouse = 5,
  EquipmentRoom = 6,
  OtherRoom = 7
}

export enum ERegionType {
  /** 未命名 */
  Default = 0,
  /** 工作区 */
  Workspace = 1,
  /** 休闲区 */
  RestArea = 2,
  /** 讨论区 */
  DiscussionForum = 3,
  /** 单间 */
  SingleRoom = 4,
  /** 接待室 */
  ReceptionRoom = 5,
  /** 设备间 */
  EquipmentRoom = 6,
  /** 前室 */
  Anteroom = 7,
  /** 前台 */
  Reception = 8,
  /** 休息室 */
  Lounge = 9,
  /** 储物间 */
  StorageRoom = 10,
  /** 网络室 */
  NetworkRoom = 11,
  /** 其他 */
  OtherRoom = 12,
  /** 通道 */
  Aisle = 13
}

export interface RegionInfo {
  type: ERoomType | ERegionType;
  name: string;
}

/**
 * 单分区房间的分区继承房间属性（见 RegionStore），type 为 ERoomType，多分区时才是 ERegionType。
 * 两个枚举数值重叠而语义不同，把分区信息写回房间前必须用它确认。
 */
export function isRoomType(type: ERoomType | ERegionType): type is ERoomType {
  return type in ERoomType;
}

export interface LineWall {
  lineSeg: LineSeg2d;
  thickness: number;
  height: number;
  offGround: number;
}

export interface SeparateLineWall extends LineWall {
  type: ESeparateWallType;
}

export enum EModelGroupType {
  furniture = 'furniture',
  assembly = 'assembly'
}
